module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_styled_01-4993841b2b264481525c85d4940849d4.jpg";